import script from "./UsersList.vue?vue&type=script&setup=true&lang=js"
export * from "./UsersList.vue?vue&type=script&setup=true&lang=js"

import "./UsersList.vue?vue&type=style&index=0&id=751875f9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-751875f9"]])

export default __exports__